import { c as _c } from "react/compiler-runtime";
import { logger } from "@justhome/common";
import { AppAccessResponse, Application, Lead, Partner, usePostAppAccess, usePostApplication } from "@justhome/api-core";
import { getFormConsentText } from "@justhome/react-ui";
import { fetchGetAssumptionsWithLogging } from "@lib/api-wrappers";
import useLanguage from "@lib/hooks/useLanguage";
import mapApplicationData from "@lib/mapApplicationData";
import { ApplicationFormValues } from "@lib/mapApplicationData/types";
import { localeToLanguageISOCode } from "@lib/utilities";
import { getOrigin } from "@lib/utm";
import { useCallback, useEffect, useRef, useState } from "react";
import { OptInFormData } from "../components/OptInForm";
interface UsePostApplicationWithAppAccessProps {
  onSuccess: (application: Application, appAccess: AppAccessResponse) => void;
  applicationForm?: ApplicationFormValues;
  partner?: Partner;
}
const usePostApplicationWithAppAccess = t0 => {
  const $ = _c(23);
  const {
    applicationForm,
    onSuccess,
    partner
  } = t0;
  const locale = useLanguage();
  const [form, setForm] = useState();
  const requestAppAccessAfterApplication = useRef(false);
  const applicationRef = useRef(undefined);
  let t1;
  if ($[0] !== onSuccess) {
    t1 = {
      onSuccess(appAccess) {
        onSuccess(applicationRef.current, appAccess);
      },
      onError(error) {
        logger.error("Error while requesting app access.", error);
      }
    };
    $[0] = onSuccess;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isLoading: isAppAccessLoading,
    isError: isAppAccessError,
    mutate: postAppAccess
  } = usePostAppAccess(t1);
  let t2;
  if ($[2] !== applicationForm?.wantsToSellAProperty || $[3] !== locale || $[4] !== partner || $[5] !== postAppAccess) {
    t2 = async (optInForm, applicationId) => {
      const utmOrigin = getOrigin();
      const consentText = getFormConsentText({
        locale,
        partner
      });
      postAppAccess({
        body: {
          applicationId: applicationId ?? "",
          email: optInForm.email,
          firstName: optInForm.firstName,
          lastName: optInForm.lastName,
          phone: optInForm.phone,
          language: localeToLanguageISOCode(locale),
          origin: utmOrigin ? [utmOrigin] : [],
          partnerId: partner?.id,
          wantsToSellAProperty: applicationForm?.wantsToSellAProperty ? "YES" : "NO",
          consentText
        }
      });
    };
    $[2] = applicationForm?.wantsToSellAProperty;
    $[3] = locale;
    $[4] = partner;
    $[5] = postAppAccess;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const requestAppAccess = t2;
  let t3;
  if ($[7] !== form || $[8] !== requestAppAccess) {
    t3 = {
      onError(error_0, variables) {
        logger.error("Error while posting an application.", error_0, variables);
      },
      onSuccess: application => {
        applicationRef.current = application;
        if (requestAppAccessAfterApplication.current) {
          requestAppAccess(form, application.id);
        }
      }
    };
    $[7] = form;
    $[8] = requestAppAccess;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    mutate: postApplication,
    isLoading: isApplicationLoading,
    isError: isApplicationError
  } = usePostApplication(t3);
  let t4;
  if ($[10] !== applicationForm || $[11] !== postApplication) {
    t4 = () => {
      if (!applicationForm) {
        return;
      }
      const saveApplication = async values => {
        const assumptions = await fetchGetAssumptionsWithLogging({
          queryParams: {
            zipCode: values.postalCode
          }
        });
        const origin = getOrigin();
        const application_0 = mapApplicationData(values, assumptions, origin);
        postApplication({
          body: {
            ...application_0,
            id: applicationRef.current?.id
          }
        });
      };
      saveApplication(applicationForm);
    };
    $[10] = applicationForm;
    $[11] = postApplication;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== applicationForm || $[14] !== locale || $[15] !== postApplication) {
    t5 = [postApplication, applicationForm, locale];
    $[13] = applicationForm;
    $[14] = locale;
    $[15] = postApplication;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  useEffect(t4, t5);
  let t6;
  if ($[17] !== requestAppAccess) {
    t6 = async values_0 => {
      setForm(values_0);
      if (applicationRef.current) {
        requestAppAccess(values_0, applicationRef.current.id);
      } else {
        requestAppAccessAfterApplication.current = true;
      }
    };
    $[17] = requestAppAccess;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const handleSubmit = t6;
  const t7 = form && isApplicationLoading || isAppAccessLoading;
  const t8 = form && isApplicationError || isAppAccessError;
  let t9;
  if ($[19] !== handleSubmit || $[20] !== t7 || $[21] !== t8) {
    t9 = {
      isLoading: t7,
      handleSubmit,
      isError: t8
    };
    $[19] = handleSubmit;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default usePostApplicationWithAppAccess;